import axios from 'axios';

let clienteAxios = axios.create({
	// baseURL: 'http://localhost:8080',
	// baseURL: process.env.REACT_APP_HEROKU_API_URL || 'http://localhost:8080',
	baseURL: process.env.REACT_APP_HEROKU_API_URL || 'https://celebremos-api.herokuapp.com',
	// headers: {
	 //	'content-type': 'application/json',
	 //	'Access-Control-Allow-Origin': '*',
	 //},
});

export default clienteAxios;
